export const delayedOrderDeliveryStepSizes = [5, 10, 15, 20, 30];
export const MINUTES_IN = {
    HOUR: 60,
    DAY: 60 * 24,
    WEEK: 60 * 24 * 7,
};
export const DELAYED_OPTIONS_MINUTES_STEP = 5;
export var ReceiveMethodEnum;
(function (ReceiveMethodEnum) {
    ReceiveMethodEnum["PICKUP"] = "pickup";
    ReceiveMethodEnum["DELIVERY"] = "delivery";
})(ReceiveMethodEnum || (ReceiveMethodEnum = {}));
//# sourceMappingURL=delayed-order.interface.js.map